export default {
  'en-US': {
    filters: {
      BatchId: 'Batch ID',
      Channel: 'Source',
      ContainsProduct: 'Product',
      DestinationCountry: 'Destination Country',
      ExceptionStatusReason: 'Exception Status Reason',
      ExcludePostCutOffProcessing: 'Exclude Post Cut-Off Processing',
      FulfillmentCenter: 'Fulfillment Center',
      FulfillmentCost: 'Fulfillment Cost',
      HasDimensions: 'Has Dimensions',
      HasTrackingNumber: 'Has Tracking Number',
      HasGiftNote: 'Has Gift Note',
      ImportDate: 'Import Date',
      IsLabelPrinted: 'Is Label Printed',
      IsPicked: 'Is Picked',
      ItemQuantity: 'Item Quantity',
      OnHoldStatusReason: 'On Hold Status Reason',
      OrderStatus: 'Status',
      ProcessedUsingBatch: 'Processed Using Batch',
      ReservedForBatch: 'Reserved for Batch',
      ShipDate: 'Ship Date',
      StoreOrderId: 'Store Order ID',
      PurchaseDate: 'Purchase Date',
      CompletedStatus: 'Completed Status',
      PossibleValues: {
        Boolean: {
          Yes: 'Yes',
          No: 'No'
        }
      },
      Placeholders: {
        SelectFilterText: 'Select a filter...',
        SelectValueText: 'Select a value...'
      }
    }
  },
  'ja-JP': {
    filters: {
      BatchId: 'バッチID',
      Channel: 'ソース',
      ContainsProduct: '製品',
      DestinationCountry: '行き先国',
      ExceptionStatusReason: '例外ステータスの理由',
      ExcludePostCutOffProcessing: 'ポストカット処理を除外する',
      FulfillmentCenter: 'フルフィルメントセンター',
      FulfillmentCost: 'フルフィルメント・コスト',
      HasDimensions: '寸法がある',
      HasTrackingNumber: '追跡番号を持つ',
      ImportDate: '輸入日',
      IsLabelPrinted: 'ラベルが印刷されていますか？',
      IsPicked: '拾われる',
      ItemQuantity: '品目数量',
      OnHoldStatusReason: '保留状態の理由',
      OrderStatus: '注文の状況',
      ProcessedUsingBatch: 'バッチを使用して処理される',
      ReservedForBatch: 'バッチ用に予約済み',
      ShipDate: '出荷日',
      StoreId: '店舗ID',
      PurchaseDate: '購入日',
      CompletedStatus: '完了ステータス',
      PossibleValues: {
        Boolean: {
          Yes: 'はい',
          No: 'いいえ'
        }
      },
      Placeholders: {
        SelectFilterText: 'フィルタを選択...',
        SelectValueText: '値を選択...'
      }
    }
  }
}

